export var CustomerChatMessageType;
(function (CustomerChatMessageType) {
    CustomerChatMessageType["PLAIN_TEXT"] = "PLAIN_TEXT";
    CustomerChatMessageType["RESERVATION_TICKET"] = "RESERVATION_TICKET";
    CustomerChatMessageType["VEHICLE_RECOMMENDATION_CAROUSEL"] = "VEHICLE_RECOMMENDATION_CAROUSEL";
    CustomerChatMessageType["PAYMENT"] = "PAYMENT";
    CustomerChatMessageType["RESERVATION_CONFIRM"] = "RESERVATION_CONFIRM";
})(CustomerChatMessageType || (CustomerChatMessageType = {}));
